import React from 'react';
import flux from 'utils/flux';

var SubmissionLink = React.createClass({

    displayName: 'SubmissionLink',

    render() {
        const { allowSubmissions, submissionLink } = flux.getStore('app').getState().config.toJS();

        if ( !allowSubmissions ) {
            return false;
        }

        return (
            <a className="awards-button btn btn-border" href={submissionLink} target="_blank">
                <span className="awards-button__label awards-button__label--full">{flux.t('submit_media')}</span>
                <span className="awards-button__label awards-button__label--short">{flux.t('submit_media_short')}</span>
            </a>
        );
    }
});

module.exports = SubmissionLink;



// WEBPACK FOOTER //
// ./app/components/header/submissionLink.jsx